const l = {
  name: "OptOut",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34.6 40" style="enable-background:new 0 0 34.6 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.3,0L22,4.7l-1.4,1.4l-2.3-2.3V12h-2V3.9L14,6.1l-1.4-1.4L17.3,0z"/>
		<path class="st0" d="M20.6,33.9l-2.3,2.2V28h-2v8.2L14,33.9l-1.4,1.4l4.7,4.7l4.7-4.7L20.6,33.9z"/>
		<path class="st0" d="M3.7,24.1l-0.8,3.2l7.1-4.1l1,1.7L3.9,29l3.1,0.8l-0.5,1.9L0,30l1.7-6.4L3.7,24.1z"/>
		<path class="st0" d="M27.7,10.2l3.1,0.8l-7.1,4.1l1,1.7l7.1-4.1L31,15.9l1.9,0.5l1.7-6.4l-6.4-1.7L27.7,10.2z"/>
		<path class="st0" d="M31,24.1l0.8,3.1l-7.1-4.1l-1,1.7l7.1,4.1l-3.2,0.8l0.5,1.9l6.4-1.7l-1.7-6.4L31,24.1z"/>
		<path class="st0" d="M6.9,10.2l-3.2,0.8l7.1,4.1l-1,1.7l-7.1-4.1l0.8,3.1l-1.9,0.5L0,10l6.4-1.7L6.9,10.2z"/>
		<path class="st0" d="M17.3,14c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S20.6,14,17.3,14z M13.3,20c0-2.2,1.8-4,4-4s4,1.8,4,4
			s-1.8,4-4,4S13.3,22.2,13.3,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as OptOut
};
